import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
/**
 *
 * @param props
 */
var DivComp = function (props) {
    var clazzName = joinClasses(props.transparent === true ? undefined : "scl-h-background", props.className);
    return (React.createElement("div", { className: clazzName, style: props.style }, props.children));
};
/**
 *
 */
export var Div = asThemeConsumer(DivComp, undefined);
